import { render } from "./Register.vue?vue&type=template&id=48300266&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=48300266&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48300266"]])

export default __exports__